export const formInputs = {
	init: function (inputs = document) {
		[].forEach.call(inputs, input => {
			if ( input.type != 'checkbox' && input.type != 'radio'  && input.type != 'file' && input.type != 'submit' && input.type != 'hidden' ) {
				input.addEventListener('input', _ => {
					if (input.value.length > 0){
						input.parentNode.classList.add('filled');
					}else{
						input.parentNode.classList.remove('filled');
					}
					if (input.parentNode.classList.contains("has-error")) {
						input.parentNode.classList.remove('has-error');
					}
				});
				input.addEventListener('focus', _ => {
					input.parentNode.classList.add('focus');
				});
				input.addEventListener('focusout', _ => {
					input.parentNode.classList.remove('focus');
				});
			} else if (input.type == 'checkbox') {
				input.addEventListener('click', _ => {
					if (input.parentNode.parentNode.classList.contains("has-error")) {
						input.parentNode.parentNode.classList.remove('has-error');
					}
				});
			}
		})

	}
};








// export const validate = {
// 	init: function () {
// 		const formsToValidate = document.querySelectorAll('.form.validate, .form-validate');
// 		[].forEach.call(formsToValidate, form => {
// 			const inputsToValidate = form.querySelectorAll('input[data-validation-rule]');
// 			[].forEach.call(inputsToValidate, input => this.validateInputs(input));
// 		});
// 	},
// 	isNumeric: function (n) {
// 		return !isNaN(parseFloat(n)) && isFinite(n);
// 	},
// 	phoneNumber: function (input) {
// 		input.addEventListener('focus', _ => {
// 			// input.value.indexOf('+48 ') < 0 ? input.value = '+48 ' + input.value : null; 
// 		});

// 		input.addEventListener('keydown', (e) => {
// 			let key = Number(e.key)
// 			let valueLength = input.value.length;

// 			if (e.keyCode === 32) e.preventDefault();
// 			if (valueLength < 5 && e.keyCode === 8) e.preventDefault(); 
// 			if (isNaN(key) && (e.keyCode !== 8 && e.keyCode !== 46 && e.keyCode !== 9)) e.preventDefault();
// 		});
// 		input.addEventListener('keyup', (e) => {
// 			let key = Number(e.key);
// 			// console.log(this.isNumeric(key), input.value.indexOf('+48 '));
// 			if (this.isNumeric(key) && input.value.indexOf('+48 ') < 0) {
// 				input.value = '+48 ' + input.value;
// 			}
// 		});

// 		input.addEventListener('focusout', _ => {
// 			if (input.value.length < 5) {
// 				input.value = '';
// 				input.classList.remove('filled');
// 			}
// 		});
// 	},
// 	// zipCode: function (input) {
// 	// 	input.addEventListener('keydown', (e) => {
// 	// 		let key = Number(e.key)			
// 	// 		if (e.keyCode === 32) e.preventDefault();
// 	// 		if (isNaN(key) && (e.keyCode !== 8 && e.keyCode !== 46 && e.keyCode !== 9 && e.keyCode !== 173)) 
// 	// 		{
// 	// 			e.preventDefault();
// 	// 		}
// 	// 		if (e.keyCode === 173 && input.value.length !== 2)
// 	// 		{
// 	// 			e.preventDefault();
// 	// 		}		

// 	// 		if (this.isNumeric(key) && input.value.length == 2) {
// 	// 			input.value = input.value + '-';				
// 	// 			this.setCaretPosition(input, input.value.length);
// 	// 		}
// 	// 	});
// 	// 	input.addEventListener('input', (e) => {
// 	// 		let key = Number(e.target.value.charAt(e.target.value.length - 1))
// 	// 		let keyCode = e.target.value.charAt(e.target.value.length - 1).charCodeAt();
// 	// 		// alert(keyCode, input.value.length);
// 	// 		if (keyCode === 32) input.value = input.value.slice(0, input.value.length - 1);
// 	// 		if (isNaN(key) && (keyCode !== 8 && keyCode !== 46 && keyCode !== 9 && keyCode !== 173 && keyCode !== 45)) 
// 	// 		{
// 	// 			input.value = input.value.slice(0, input.value.length - 1);
// 	// 		}			
// 	// 		if ((keyCode === 173 || keyCode === 45)  && input.value.length !== 3)
// 	// 		{
// 	// 			input.value = input.value.slice(0, input.value.length - 1);
// 	// 		}		

// 	// 		if (this.isNumeric(key) && input.value.length == 3) {
// 	// 			input.value = input.value.slice(0, input.value.length - 1) + '-' + input.value.slice(input.value.length - 1, input.value.length);
// 	// 			alert(input + " " + input.value.length);
// 	// 			this.setCaretPosition(input, input.value.length + 1);
// 	// 		}
// 	// 	});		
// 	// },
// 	validateInputs: function () {
// 		const argsLen = arguments.length;
// 		if (!argsLen) return;

// 		for (let i = 0; i < argsLen; i++) {
// 			this[arguments[i].dataset.validationRule](arguments[i]);
// 		}
// 	},
// 	moveLabelInside: function () {
// 		const formValidate = document.querySelector(".form.validate");
// 		if (!formValidate) return;
// 		const inputWrapper = formValidate.querySelector("div");
// 		if (!inputWrapper) return;
// 		const formInput = inputWrapper.querySelector('input[type="tel"]');
// 		if (!formInput) return;
// 		const formLabel = formValidate.querySelector("label");
// 		if (!formLabel) return;
// 		inputWrapper.appendChild(formLabel);
// 		this.appendHighlights(formInput);
// 	},
// 	appendHighlights: function (formInput) {
// 		const highlightSpan = document.createElement('span');
// 		const barSpan = document.createElement('span');
// 		highlightSpan.setAttribute('class', 'highlight');
// 		barSpan.setAttribute('class', 'bar');
// 		formInput.parentNode.insertBefore(highlightSpan, formInput.nextSibling);
// 		formInput.parentNode.insertBefore(barSpan, formInput.nextSibling);
// 	},
// 	setCaretPosition: function (ctrl, pos) {
// 		// Modern browsers
// 		if (ctrl.setSelectionRange) {
// 			ctrl.focus();
// 			ctrl.setSelectionRange(pos, pos);
		
// 		// IE8 and below
// 		} else if (ctrl.createTextRange) {
// 			var range = ctrl.createTextRange();
// 			range.collapse(true);
// 			range.moveEnd('character', pos);
// 			range.moveStart('character', pos);
// 			range.select();
// 		}
// 	}
// };
